"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewFilterDerivate = void 0;
const lodash_1 = require("lodash");
const field_1 = require("../../../model/field");
const datasheet_1 = require("../../../model/datasheet");
const datasheet_2 = require("../../../modules/database/store/selectors/resource/datasheet");
const view_types_1 = require("../../../types/view_types");
const field_types_1 = require("../../../types/field_types");
class ViewFilterDerivate {
    constructor(state, datasheetId) {
        this.state = state;
        this.datasheetId = datasheetId;
        /**
         * Currently only to lookup with, TODO: change the method to lookup, the follow-up to go deprecated
         * @param data
         */
        this.getFilteredRecords = (data) => {
            var _a;
            const { linkFieldRecordIds, filterInfo } = data;
            const snapshot = (_a = this.state.datasheetMap[this.datasheetId]) === null || _a === void 0 ? void 0 : _a.datasheet.snapshot;
            if (!linkFieldRecordIds || !snapshot) {
                return [];
            }
            const recordMap = snapshot.recordMap;
            const _filterInfo = (0, datasheet_2.getFilterInfoExceptInvalid)(this.state, this.datasheetId, filterInfo);
            if (!_filterInfo) {
                return linkFieldRecordIds;
            }
            const result = linkFieldRecordIds.filter(linkFieldRecordId => {
                const record = recordMap[linkFieldRecordId];
                return this.checkConditions(record, _filterInfo);
            });
            const maxConditon = filterInfo.conditions.find(condition => {
                if (condition.operator == view_types_1.FOperator.IsMax)
                    return true;
                return false;
            });
            if (maxConditon) {
                return this.findMaxRow(result, maxConditon.fieldId);
            }
            const minConditon = filterInfo.conditions.find(condition => {
                if (condition.operator == view_types_1.FOperator.IsMin)
                    return true;
                return false;
            });
            if (minConditon) {
                return this.findMinRow(result, minConditon.fieldId);
            }
            return result;
        };
    }
    /**
     * Filter out duplicate cellValue, return the de-duplicated rows,
     * only allow adding one with duplicate conditions
     *
     * TODO: Repeat is not quite in line with the logic of "filtering",
     * it should be a separate function, and the following calculation is not rigorous, it needs to be rewritten.
     */
    findRepeatRow(rows, fieldId, isAnd) {
        var _a;
        const map = new Map();
        const state = this.state;
        const snapshot = this.state.datasheetMap[this.datasheetId].datasheet.snapshot;
        const field = snapshot.meta.fieldMap[fieldId];
        const fieldMethod = field_1.Field.bindContext(field, this.state);
        const values = datasheet_1.DatasheetActions.getCellValuesByFieldId(state, snapshot, field.id, undefined, true);
        if (values === null || values === void 0 ? void 0 : values.length) {
            for (const row of rows) {
                const needTranslate = [
                    field_types_1.FieldType.Currency,
                    field_types_1.FieldType.SingleText,
                    field_types_1.FieldType.Text,
                    field_types_1.FieldType.URL,
                    field_types_1.FieldType.Phone,
                    field_types_1.FieldType.Email,
                    field_types_1.FieldType.DateTime,
                    field_types_1.FieldType.CreatedTime,
                    field_types_1.FieldType.LastModifiedTime,
                    field_types_1.FieldType.Number,
                    field_types_1.FieldType.Percent,
                ];
                let cellValue = (0, datasheet_2.getCellValue)(state, snapshot, row.recordId, field.id);
                const lookUpField = (0, datasheet_2.findRealField)(state, field);
                const rollUpType = ((_a = field.property) === null || _a === void 0 ? void 0 : _a.rollUpType) || field_types_1.RollUpFuncType.VALUES;
                const isNeedSort = Array.isArray(cellValue) &&
                    ((field.type === field_types_1.FieldType.LookUp && rollUpType === field_types_1.RollUpFuncType.VALUES) ||
                        [field_types_1.FieldType.MultiSelect, field_types_1.FieldType.Member].includes(field.type) ||
                        field.type === field_types_1.FieldType.Link);
                if (isNeedSort) {
                    cellValue = (0, lodash_1.sortBy)(cellValue, o => (typeof o === 'object' ? o.text : o));
                }
                // Do you need to call cellValueToString to convert to string form.
                if (needTranslate.includes(field.type) ||
                    (field_types_1.FieldType.LookUp === field.type &&
                        lookUpField &&
                        ![field_types_1.FieldType.SingleSelect, field_types_1.FieldType.MultiSelect, field_types_1.FieldType.Link].includes(lookUpField.type))) {
                    cellValue = fieldMethod.cellValueToString(cellValue, { hideUnit: true }) || '';
                }
                cellValue = (cellValue === null || cellValue === void 0 ? void 0 : cellValue.toString().trim()) || '';
                if (!map.has(cellValue)) {
                    map.set(cellValue, [row.recordId]);
                    continue;
                }
                map.set(cellValue, [...map.get(cellValue), row.recordId]);
            }
        }
        const result = [];
        map.forEach(value => {
            if (value.length > 1) {
                result.push(...value);
            }
        });
        if (isAnd) {
            const recordIdMap = new Map(result.map((value, key) => [value, key]));
            return rows.filter(row => recordIdMap.has(row.recordId));
        }
        return result;
    }
    /**
     * find max or min rows,only for datetime number fileld
     *
     */
    findMaxRow(rows, fieldId) {
        const state = this.state;
        const snapshot = this.state.datasheetMap[this.datasheetId].datasheet.snapshot;
        let maxValue = Number.MIN_VALUE, maxRecordId = "";
        const field = snapshot.meta.fieldMap[fieldId];
        for (const recordId of rows) {
            let cellValue = (0, datasheet_2.getCellValue)(state, snapshot, recordId, field.id);
            if (cellValue > maxValue) {
                maxValue = cellValue;
                maxRecordId = recordId;
            }
        }
        return [maxRecordId];
    }
    /**
     * find  min rows,only for datetime number fileld
     *
     */
    findMinRow(rows, fieldId) {
        const state = this.state;
        const snapshot = this.state.datasheetMap[this.datasheetId].datasheet.snapshot;
        let minValue = Number.MAX_VALUE, minRecordId = "";
        const field = snapshot.meta.fieldMap[fieldId];
        for (const recordId of rows) {
            let cellValue = (0, datasheet_2.getCellValue)(state, snapshot, recordId, field.id);
            if (cellValue < minValue) {
                minValue = cellValue;
                minRecordId = recordId;
            }
        }
        return [minRecordId];
    }
    doFilter(condition, field, cellValue) {
        const fieldMethod = field_1.Field.bindContext(field, this.state);
        /**
         *  isEmpty, isNotEmpty call generic logic
         */
        if (condition.operator === view_types_1.FOperator.IsEmpty || condition.operator === view_types_1.FOperator.IsNotEmpty) {
            return fieldMethod.isEmptyOrNot(condition.operator, cellValue);
        }
        /**
         *  In the non-isEmpty || isNotEmpty condition, if the value is not filled in, no filtering is done.
         */
        if (condition.value == null && fieldMethod.basicValueType !== field_types_1.BasicValueType.Number && condition.operator !== view_types_1.FOperator.IsRepeat) {
            return true;
        }
        /**
         * Call the field's own operator calculation function to calculate.
         */
        return fieldMethod.isMeetFilter(condition.operator, cellValue, condition.value);
    }
    doFilterOperations(condition, record, repeatRows) {
        var _a;
        /**
         * or condition to have repeatRows
         * or condition on the presence or absence of repeatRows
         */
        if (repeatRows === null || repeatRows === void 0 ? void 0 : repeatRows.includes(record.id)) {
            return true;
        }
        // If the condition is isRepeat, and no duplicate records are hit, return false early
        if (condition.operator === view_types_1.FOperator.IsRepeat) {
            return false;
        }
        //max at the last do the filter
        if (condition.operator === view_types_1.FOperator.IsMax) {
            return true;
        }
        if (condition.operator === view_types_1.FOperator.IsMin) {
            return true;
        }
        const snapshot = (_a = this.state.datasheetMap[this.datasheetId]) === null || _a === void 0 ? void 0 : _a.datasheet.snapshot;
        if (!snapshot) {
            return false;
        }
        const { fieldId } = condition;
        const field = snapshot.meta.fieldMap[fieldId];
        // currently, we don't filter data by the columns without permission,
        // so we need to ignore the permission check when get `cellValue`
        const cellValue = (0, datasheet_2.getCellValue)(this.state, snapshot, record.id, fieldId, undefined, undefined, true);
        try {
            return this.doFilter(condition, field, cellValue);
        }
        catch (error) {
            // FIXME: calc fields transform cause filter match error
            return false;
        }
    }
    /**
     * Check if a record meets the conditions in filterCondition
     */
    checkConditions(record, filterInfo, repeatRows) {
        const conditions = filterInfo.conditions;
        if (!record) {
            return false;
        }
        if (filterInfo.conjunction === view_types_1.FilterConjunction.And) {
            return conditions.every(condition => this.doFilterOperations(condition, record, undefined));
        }
        if (filterInfo.conjunction === view_types_1.FilterConjunction.Or) {
            return conditions.some(condition => this.doFilterOperations(condition, record, repeatRows));
        }
        // never happen
        return false;
    }
    getFilterRowsBase(props) {
        let filterInfo = props.filterInfo;
        const recordMap = props.recordMap;
        let rows = props.rows;
        if (!filterInfo) {
            return rows;
        }
        const isRepeatCondition = filterInfo.conditions.find(condition => condition.operator === view_types_1.FOperator.IsRepeat);
        const isAnd = filterInfo.conjunction === view_types_1.FilterConjunction.And;
        let repeatRows;
        if (isRepeatCondition) {
            if (isAnd) {
                rows = this.findRepeatRow(rows, isRepeatCondition.fieldId, true);
                const filteredConditions = filterInfo.conditions.filter(condition => condition.operator !== view_types_1.FOperator.IsRepeat);
                filterInfo = Object.assign(Object.assign({}, filterInfo), { conditions: filteredConditions });
            }
            else {
                repeatRows = this.findRepeatRow(rows, isRepeatCondition.fieldId);
            }
        }
        const result = rows.filter(row => {
            return this.checkConditions(recordMap[row.recordId], filterInfo, repeatRows);
        });
        return result;
    }
    // TODO: mirrorFilter is no longer a direct source view filter.
    getFilteredRows(view) {
        var _a, _b, _c, _d, _e, _f, _g;
        const snapshot = (_a = this.state.datasheetMap[this.datasheetId]) === null || _a === void 0 ? void 0 : _a.datasheet.snapshot;
        if (!view.rows || !snapshot) {
            return [];
        }
        const recordMap = snapshot.recordMap;
        // TODO: empty data filter, subsequent data repair should be able to delete
        const rows = view.rows.filter(row => recordMap[row.recordId]); //删除掉rows结构，不然严重影响性能
        //if(rows.length<=0)
        //Object.keys(recordMap).forEach(recordId=>{rows.push({recordId:recordId,hidden:false})})
        const filterInfo = (0, datasheet_2.getFilterInfoExceptInvalid)(this.state, this.datasheetId, view.filterInfo);
        const viewRows = this.getFilterRowsBase({ filterInfo, rows, recordMap });
        const mirrorId = this.state.pageParams.mirrorId;
        const mirrorFilter = (_d = (_c = (_b = this.state.mirrorMap[mirrorId]) === null || _b === void 0 ? void 0 : _b.mirror) === null || _c === void 0 ? void 0 : _c.temporaryView) === null || _d === void 0 ? void 0 : _d.filterInfo;
        const mirrorSourceDatasheetId = (_g = (_f = (_e = this.state.mirrorMap[mirrorId]) === null || _e === void 0 ? void 0 : _e.mirror) === null || _f === void 0 ? void 0 : _f.sourceInfo) === null || _g === void 0 ? void 0 : _g.datasheetId;
        if (!mirrorFilter || snapshot.datasheetId !== mirrorSourceDatasheetId) {
            return viewRows;
        }
        /**
         * Filter again in the presence of mirror
         */
        return this.getFilterRowsBase({ filterInfo: mirrorFilter, rows: viewRows, recordMap });
    }
}
exports.ViewFilterDerivate = ViewFilterDerivate;
//# sourceMappingURL=view_filter_derivate.js.map